import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col space-x-2" };
const _hoisted_2 = { class: "text-lg text-gray-900 font-semibold" };
const _hoisted_3 = { class: "w-48 flex flex-row items-center" };
const _hoisted_4 = {
    class: "px-2 flex flex-row items-center space-x-3",
    style: { "width": "100px" }
};
const _hoisted_5 = { class: "text-sm text-gray-900 font-medium" };
import { useHistoryStore } from '@/store/history';
import { ReverseLeftIcon, ReverseRightIcon, XIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIDivider, UISpace, UITooltip } from '@gohighlevel/ghl-ui';
import { computed, inject } from 'vue';
import { applyHistory } from '@/compositions/useHistoryHelper';
import EmitterEvent from '@/events';
import { HistoryType } from '@/types/history';
import { Tools } from '@/types/tools';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalHeaderV2',
    props: {
        loading: {
            type: Boolean,
            require: true,
        },
        stage: {
            type: Object,
            require: true,
        },
        disableAction: {
            type: Boolean,
            require: true,
        },
    },
    emits: ['close', 'load-image'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const historyStore = useHistoryStore();
        const emitter = inject('emitter');
        const isUndoEnable = computed(() => historyStore.historyIndex !== -1);
        const isRedoEnable = computed(() => historyStore.history.length - 1 !== historyStore.historyIndex);
        function closeEditor() {
            emits('close');
        }
        function undo() {
            if (!isUndoEnable.value || props.loading || props.disableAction)
                return;
            const history = historyStore.undo();
            if (history) {
                if (history.type === HistoryType.REPLACE && history.before.blob) {
                    emits('load-image', history.before.blob);
                    return;
                }
                const obj = props.stage.find(`#${history.id}`)[0];
                applyHistory(obj, history.source, history.before);
                setToolsProperties(history.source, history.before);
            }
        }
        function redo() {
            if (!isRedoEnable.value || props.loading || props.disableAction)
                return;
            const history = historyStore.redo();
            if (history) {
                if (history.type === HistoryType.REPLACE && history.after.blob) {
                    emits('load-image', history.after.blob);
                    return;
                }
                const obj = props.stage.find(`#${history.id}`)[0];
                applyHistory(obj, history.source, history.after);
                setToolsProperties(history.source, history.after);
            }
        }
        function setToolsProperties(source, history) {
            var _a, _b;
            let historySet;
            if (source !== Tools.CROP) {
                let filterName = '';
                const customFilter = (_a = history.filters) === null || _a === void 0 ? void 0 : _a.filters.find((f) => { var _a; return (_a = f.name) === null || _a === void 0 ? void 0 : _a.includes('customFilter'); });
                if (customFilter) {
                    filterName = customFilter.name.split('_')[1];
                }
                historySet = {
                    source: source,
                    filterValues: ((_b = history.filters) === null || _b === void 0 ? void 0 : _b.values) || [],
                    filterName,
                };
            }
            emitter.emit(EmitterEvent.IMAGE_EDITOR_HISTORY_SET, historySet);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_unref(UISpace), {
                        justify: "space-between",
                        align: "center"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('common.title')), 1),
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_unref(UITooltip), null, {
                                        trigger: _withCtx(() => [
                                            _createVNode(_unref(ReverseLeftIcon), {
                                                class: _normalizeClass([
                                                    _unref(isUndoEnable)
                                                        ? 'text-gray-700 cursor-pointer'
                                                        : 'text-gray-400 cursor-not-allowed',
                                                    "w-6 h-6"
                                                ]),
                                                onClick: undo
                                            }, null, 8, ["class"])
                                        ]),
                                        default: _withCtx(() => [
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.undo')), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(UITooltip), null, {
                                        trigger: _withCtx(() => [
                                            _createVNode(_unref(ReverseRightIcon), {
                                                class: _normalizeClass([
                                                    _unref(isRedoEnable)
                                                        ? 'text-gray-700 cursor-pointer'
                                                        : 'text-gray-400 cursor-not-allowed',
                                                    "w-6 h-6"
                                                ]),
                                                onClick: redo
                                            }, null, 8, ["class"])
                                        ]),
                                        default: _withCtx(() => [
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.redo')), 1)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _createVNode(_unref(UIDivider), { vertical: true }),
                                _createElementVNode("div", {
                                    class: "flex justify-end cursor-pointer",
                                    style: { "width": "60px" },
                                    onClick: closeEditor
                                }, [
                                    _createVNode(_unref(XIcon), { class: "w-6 h-6 text-gray-900" })
                                ])
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('common.subtitle')), 1)
            ], 64));
        };
    }
});
